/**
 * Storage keys
 *
 * AXF-1013: the three auth keys (`auth_token`, `axflow_admin_session`, `admin_user`) are gone with
 * the portal's own session. The cookie is the single source of truth; nothing here may cache it.
 */
export const STORAGE_KEYS = {
  LANGUAGE: 'app_language',
} as const

/**
 * Route paths
 */
export const ROUTES = {
  HOME: '/',
  // AXF-1013: `/auth/login` now serves the resting page, and there is no callback — the portal
  // never starts a login, so it never receives one.
  LOGIN: '/auth/login',
  DASHBOARD: '/dashboard',
  HEALTH: '/health',
  AUDIT: '/audit',
  PRESENTATION: '/presentation',
  WORKFLOWS: '/workflows',
  EXECUTIONS: '/executions',
  MONITORING: '/monitoring',
  DEPLOYMENT: '/deployment',
  LIVE_TESTS: '/live-tests',
  LIVE_TESTS_RUN: '/live-tests/runs/:runId',
  LIVE_TESTS_HISTORY: '/live-tests/history',
  CONNECTORS: '/connectors',
  GROUPS: '/groups',
  TENANTS: '/tenants',
  IDENTITY_SWITCH_OVER: '/identity-switch-over',
  PERSON_EXPORT: '/person-export',
  USERS: '/users',
  TEMPLATES: '/templates',
  INFRA: '/infra',
  INFRA_REDIS: '/infra/redis',
  INFRA_SERVICE_BUS: '/infra/service-bus',
  INFRA_DB: '/infra/db/:schema',
  INFRA_DB_TABLE: '/infra/db/:schema/:table',
  WHATS_NEW: '/whats-new',
  FORBIDDEN: '/403',
  NOT_FOUND: '/404',
} as const

export const liveTestsRunPath = (runId: string) => `/live-tests/runs/${runId}`
